import ajax from "./request.js";
import store from "@/store";

let bool = process.env.NODE_ENV === "production";
const href = bool
  ? `https://${window.location.host}/api/cloud/projectPublic`
  : "/api/cloud/projectPublic";
const href1 = bool
  ? `https://${window.location.host}/api/cloud/welcome/findList`
  : "/api/cloud/welcome/findList";

function queryCommonTemplates(data) {
  return ajax(`${href}/list`, {
    method: "POST",
    data,
  });
}

function deleteCommonTemplates(data) {
  return ajax(`${href}/deleteByIds`, {
    method: "POST",
    data,
  });
}

function getDownloadList(data) {
  return ajax(`${href1}`, {
    method: "POST",
    data,
  });
}

const downloadBase = href1.replace(/\/findList$/, "");

function listClientDownloadVersions(data) {
  return ajax(`${downloadBase}/download/versions`, {
    method: "POST",
    data,
  });
}

function resolveClientDownload(data) {
  return ajax(`${downloadBase}/download/resolve`, {
    method: "POST",
    data,
  });
}

function getClientPackageDownloadUrl(data) {
  const params = new URLSearchParams();
  const entries = {
    client_type: data && data.client_type,
    version_id: data && data.version_id,
    cpu_arch: data && data.cpu_arch,
    platform_variant: data && data.platform_variant,
    version_name: data && data.version_name,
  };
  Object.keys(entries).forEach((key) => {
    const val = entries[key];
    if (val != null && String(val) !== "") {
      params.set(key, String(val));
    }
  });
  if (!params.get("client_type")) {
    return "";
  }
  return `${downloadBase}/download/file?${params.toString()}`;
}

function downloadClientPackageFile(data, suggestedName) {
  const token =
    (store.state &&
      store.state.loginAccountInfo &&
      store.state.loginAccountInfo.token) ||
    "";
  const url = `${downloadBase}/download/file`;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    if (token) {
      xhr.setRequestHeader("token", token);
    }
    xhr.onload = function () {
      const blob = xhr.response;
      const type = (blob && blob.type) || "";
      if (type.indexOf("application/json") > -1) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const json = JSON.parse(reader.result);
            reject(new Error((json && json.msg) || "下载失败"));
          } catch (e) {
            reject(e);
          }
        };
        reader.readAsText(blob);
        return;
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        let filename = suggestedName || "download";
        const dispo = xhr.getResponseHeader("Content-Disposition") || "";
        const star = dispo.match(/filename\*=UTF-8''([^;]+)/i);
        const plain = dispo.match(/filename="([^"]+)"/i) || dispo.match(/filename=([^;]+)/i);
        if (star && star[1]) {
          filename = decodeURIComponent(star[1].trim());
        } else if (plain && plain[1]) {
          filename = decodeURIComponent(plain[1].replace(/"/g, "").trim());
        }
        const outBlob =
          blob.type && blob.type !== "application/json"
            ? blob
            : new Blob([blob], { type: "application/octet-stream" });
        const objectUrl = window.URL.createObjectURL(outBlob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        window.setTimeout(() => {
          if (a.parentNode) {
            a.parentNode.removeChild(a);
          }
          window.URL.revokeObjectURL(objectUrl);
        }, 2000);
        resolve({ status: "success" });
        return;
      }
      reject(new Error("下载失败"));
    };
    xhr.onerror = () => reject(new Error("下载失败"));
    xhr.send(JSON.stringify(data || {}));
  });
}

function listClientReleaseCatalog(data) {
  return ajax(`${downloadBase}/download/releases`, {
    method: "POST",
    data,
  });
}

export default {
  queryCommonTemplates,
  deleteCommonTemplates,
  getDownloadList,
  listClientDownloadVersions,
  resolveClientDownload,
  downloadClientPackageFile,
  getClientPackageDownloadUrl,
  listClientReleaseCatalog,
};
